/**
 * apiUrl vazio = mesmo origem via Vite proxy (necessario pra cookie SameSite=Lax em dev).
 * Em prod: VITE_API_URL=https://bookdental.com.br.
 */
export const env = {
  apiUrl: import.meta.env.VITE_API_URL ?? "",
  landingUrl: import.meta.env.VITE_LANDING_URL ?? "http://localhost:3003",
} as const;
